import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 拜访列表
 */
export function getPageList(data) {
  return fetch({
    url: '/sale/project/visit/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除记录
 */
export function deleteData(data) {
  return fetch({
    url: '/sale/project/visit/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存记录
 */
export function saveData(data) {
  return fetch({
    url: '/sale/project/visit/save',
    method: 'POST',
    data
  })
}
/**
 * 上传附件
 *
 */
export function uploadFile(data) {
  return fetch({
    url: '/foreign/storage/uploadFile',
    method: 'POST',
    data
  })
}

/**
 * 用户下啦接口
 * @param {*}
 */
export function getUserSimpleList(data) {
  return fetch({
    url: '/auth/subPlatform/user/simpleList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 技术材料下拉
 */
export function getTechnicalDocumentSimpleList() {
  return fetch({
    url: '/maintain/TechnicalDocument/simpleList',
    method: 'POST',
  })
}






// WEBPACK FOOTER //
// ./src/api/salesManagement/bfjl.js